import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { Business, UpdateBusinessInput } from "@adva/types";

type BusinessResponse = { business: Business };

export function useCurrentBusiness() {
  return useQuery({
    queryKey: ["current-business"],
    queryFn: () => api.get<BusinessResponse>("/core/me/business"),
  });
}

export function useUpdateBusiness() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateBusinessInput) =>
      api.patch<BusinessResponse>("/core/me/business", data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["current-business"] });
    },
  });
}
